import React, { useEffect, useRef } from 'react';
import { cn } from '../../../utils/utils';
import { ReactComponent as AddImgSvg } from '../../../assets/svgs/add_img.svg';
// import bgIcon from '../../../assets/bg.png';
// import pauseIcon from '../../../assets/images/pause.png';
import { ReactComponent as DeleteSvg } from '../../../assets/svgs/delete.svg';

import { Button, Upload } from 'antd';
import ModalCom from '../../../components/ModalCom/index.jsx';
import SvgCom from '../../../components/SvgCom/index.jsx';
import { useState } from 'react';
import { putShowreel, uploadVideo } from '../../../api/request.js';
import moment from 'moment';

const { Dragger } = Upload;

const UploadSlideWinCom = ({showWin, newSlide, className ='', onCloseWin, onRefresh}) => {
  const [ curFile, setCurFile ] = useState(null);
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    if(!showWin) {
      setCurFile(null);
      setLoading(false);
    }
  }, [showWin]);

  const props = {
    multiple: false,
    showUploadList: false,
    accept: ['.mp4'],
    beforeUpload: (file) => {
      setCurFile(file);
    },
    customRequest: () => {}
  };

  const fnDelVideo = () => {
    if(loading) return;
    setCurFile(null);
  };

  const fnFetchUpload = async () => {
    if(!curFile) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', curFile);
      const result = await uploadVideo(formData);
      if(result.status === 'Success') {
        const { video_path } = result.data;
        const { id, target_id, position } = newSlide;
        const response = await putShowreel( id, {
          add_slide: {
            extra_video_path: video_path,
            target_id,
            position
          }
        });
        if(response.status === 'Success') {
          onCloseWin(false);
          onRefresh();
        }
      }
    } catch(error) {
      //
    } finally {
      setLoading(false);
    }
  };

  return <ModalCom showWin={showWin} className={cn('w-[520px]', className)} onCloseWin={onCloseWin}>
    <div className="px-[0px] relative">
      <div className="text-center">
        <span className="text-[22px] font-bold leading-none text-primary">Upload</span>
      </div>
      <div className="h-[350px] overflow-y-auto  mt-[20px]">
        {
          !curFile && 
            <Dragger {...props} className="video-popup">
              <div className="h-full w-full flex flex-col justify-center items-center bg-third rounded-md group">
                <SvgCom Svg={AddImgSvg} size="30"></SvgCom>
                <span className="text-sm mt-3 text-primary hover:font-bold">Upload or drag here</span>
              </div>
            </Dragger>
        }
        {
          curFile && <VideoItem onDel={() => fnDelVideo()} detail={curFile}></VideoItem>
          // sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6
          // <div className="grid gap-4">
          //   {
          //     fileList.map((item, index) => )
          //   }
          // </div>
        }
      </div>
      <div className="mt-[10px] text-right">
        <Button onClick={fnFetchUpload} disabled={loading} loading={loading} type="primary" className="border-none shadow-none w-[120px] rounded-xl">Upload</Button>
      </div>
    </div>
  </ModalCom>;
};

const VideoItem = ({detail, onDel}) => {
  const file = detail;
  const { name } = file;
  const videoUrl = URL.createObjectURL(file);
  const videoRef = useRef(null);
  const [ timeStr, setTimeStr ] = useState('00:00');

  useEffect(() => {
    const fnTest = () => {
      const seconds = videoRef.current.duration;
      const timerStr = moment.utc(seconds * 1000).format('mm:ss');
      setTimeStr(timerStr);
    };
    if(videoRef && videoRef.current) {
      videoRef.current.addEventListener('loadedmetadata', fnTest);
    }
    return () => {
      if(videoRef.current) {
        videoRef.current.removeEventListener('loadedmetadata', fnTest);
      }
    };
  }, [videoRef]);

  return (
    <div className={cn('bg-[#DFECDD] rounded-2xl p-[15px]')}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-base font-bold leading-none text-green-1 overflow-ellipsis overflow-hidden whitespace-nowrap">{name}</span>
      </div>
      <div className="h-[265px] rounded-md relative overflow-hidden flex items-center justify-center">
        <video src={videoUrl} ref={videoRef} controls className='w-full'></video>
        <div className="absolute bottom-3 right-3 px-2 py-1 rounded text-white text-[10px] bg-[#00A32E61]">
          {timeStr}
        </div>
        <SvgCom onClick={() => onDel && onDel()} Svg={DeleteSvg} size="28" className="absolute bottom-2.5 left-2 cursor-pointer"></SvgCom>
      </div>
    </div>
  );
};

export default UploadSlideWinCom;